/**
 * @param {string} string - Input string
 * @returns {string}
 */
export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * @param {string} a - First string (normalized)
 * @param {string} b - Second string (normalized)
 * @returns {boolean}
 */
export const stringsMatch = (a, b) => {
    a = cleanString(a);
    b = cleanString(b);

    return a === b;
};

/**
 * @param {string} string - Input string
 * @returns {string} Lowercase, single-space-joined words
 */
export const cleanString = (string) => {
    return deconstructString(string).join(" ");
};

/**
 * @param {string} string - Input string
 * @returns {string[]} Lowercase non-empty words
 */
export const deconstructString = (string) => {
    return string
        .toLowerCase()
        .split(" ")
        .filter((part) => {
            return part !== "";
        });
};

/**
 * @param {string} str - Text that may contain "Shy Aviation" or "Shy"
 * @param {boolean} isPoweredBy - Whether to replace with tenant name
 * @param {string} [tenantName] - Tenant name to substitute
 * @returns {string}
 */
export const replaceShyName = (str, isPoweredBy, tenantName) => {
    if (isPoweredBy && tenantName) {
        return str.replace(/shy aviation|shy/gi, tenantName);
    }
    return str;
};

/**
 * @param {number} metric - Length in metres
 * @returns {JSX.Element} "Xm - (feet'inches")"
 */
export const getMeasurements = (metric) => {
    const imperial = (metric * 3.2808).toString().split(".");
    let feet = imperial[0] || 0;
    let inches = imperial[1]?.slice(0, 2) || 0;

    return (
        <>
            {metric}m -{" "}
            <small>
                ({feet}'{inches}")
            </small>
        </>
    );
};
